
/**
* src/connects/user-monthly-activities-table.js
* 
*/

import { connect } from 'react-redux'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import actions from '../actions'
import { translate } from 'react-i18next'
import moment from 'moment'
import times from 'lodash/times'
import map from 'lodash/map'
import find from 'lodash/find'
import isHoliday from '../helpers/check-holiday'
import ui from '../helpers/ui-state'

export const mapStateToProps = (state, ownProps)=> {  
  return {
    isMonthlyFetching: state.activityReport.isMonthlyFetching,
    isMonthlyFetchFailed: state.activityReport.isMonthlyFetchFailed,
    activityReport: state.activityReport.monthly_item,
    isPhone: state.media.isPhone,
    isSaving: state.submissionSchedules.isSaving,
    isSaveFailed: state.submissionSchedules.isSaveFailed,
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  const _day = [
    { day: 0, label: ownProps.t('label:日') },
    { day: 1, label: ownProps.t('label:月') },
    { day: 2, label: ownProps.t('label:火') },
    { day: 3, label: ownProps.t('label:水') },
    { day: 4, label: ownProps.t('label:木') },
    { day: 5, label: ownProps.t('label:金') },
    { day: 6, label: ownProps.t('label:土') },
  ]

  const start_date = ownProps.date.clone().startOf('month')

  const report_status = stateProps.activityReport && stateProps.activityReport.activity && map(stateProps.activityReport.activity, (activity, i)=>{
    const dt = start_date.clone().add(i, 'days')
    const is_holiday = isHoliday(dt)
    const date = dt.date()
    const day = _day[dt.day()].label
    const theme = (_day[dt.day()].day == 0 || is_holiday) ? 'holiday' : _day[dt.day()].day == 6 && 'saturday' || 'default'
    const item = {
      diary: activity.diary,
      memo: activity.memo,
      kpi: activity.kpi,
      like: activity.like,
      comment: activity.comment,
    }
    const schedule_data = find(stateProps.activityReport.submission_schedules, schedules => schedules.date === dt.format('YYYY-MM-DD'))
    return {
      reported_at: dt.format('YYYY-MM-DD'),
      date: date,
      day: day,
      theme: theme,
      activity: item,
      submission: schedule_data ? schedule_data.submission : undefined,
    }
  })

  const report_two_rows = report_status && times(16, (i)=> ({
    first_half: report_status[i],
    latter_half: report_status[i + 16],
  }))

  return {
    report_status,
    report_two_rows,
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    willMount: (props)=> dispatch(actions.fetchMonthlyActivityReport(props.group_id, props.user_id, moment(props.date).format('YYYY-MM-DD'))),

    willUpdate:  (props, nextProps)=> {
      if (props.date != nextProps.date || props.user_id != nextProps.user_id) {
        dispatch(actions.fetchMonthlyActivityReport(nextProps.group_id, nextProps.user_id, moment(nextProps.date).format('YYYY-MM-DD')))
      }
      if(props.isSaving && !nextProps.isSaving && !nextProps.isSaveFailed) {
        //モーダル内の月ごとの提出データを更新させる
        dispatch(actions.fetchMonthlyActivityReport(nextProps.group_id, nextProps.user_id, moment(nextProps.date).format('YYYY-MM-DD')))
        nextProps.updateUI({ save: true })
        setTimeout(()=> nextProps.updateUI({ save: false }), 3000)
      }

      // 任意の日付を保存後、activityReportが更新されたタイミングで編集中の場合、report_status内のsubmissionが一つでもfalseだった場合はweekdaySelectを更新させる
      if(props.isMonthlyFetching && !nextProps.isMonthlyFetching && nextProps.edit) {
        const weekdaySelect = nextProps.report_status.some((status) => status.theme === 'default' && status.submission === false)
        nextProps.updateUI({ weekdaySelect: !weekdaySelect })
      }
      //編集時にreport_status内のsubmissionが一つでもfalseだった場合はweekdaySelectを更新させる
      if(props.edit != nextProps.edit && nextProps.edit === true) {
        const weekdaySelect = nextProps.report_status.some((status) => {
          if(typeof status.submission != 'undefined'){
            return status.theme === 'default' && status.submission === false
          }else {
            return true
          }
        })
        nextProps.updateUI({ weekdaySelect: !weekdaySelect })
      }
      if(props.edit != nextProps.edit && nextProps.edit === false && nextProps.reportDate){
        dispatch(actions.fetchActivityReports(nextProps.group_id, nextProps.reportDate.format('YYYY-MM-DD')))
      }
    },

    willUnmount: ()=> dispatch(actions.clearMonthlyActivityReport()),

    saveSchedules: (group_id, schedule_data, user_id) => {
      const start_date = ownProps.date.clone().startOf('month').format('YYYY-MM-DD')
      const end_date = ownProps.date.clone().endOf('month').format('YYYY-MM-DD')
      dispatch(actions.saveSubmissionSchedules(group_id, start_date, end_date, schedule_data, user_id))
    },
  }
}

export default combineHOC(
  translate(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({ state: {
    weekdaySelect: false,
    save: false
  }}),
  lifecycle,
)


// WEBPACK FOOTER //
// ./src/connects/user-monthly-activities-table.js